/*
  Cart popup for adds the theme did not make.

  The cart notification (assets/cart-notification.js) only opens when the
  theme's own <product-form> adds a product: that form asks Shopify for the
  notification's sections in the same request and hands the response to
  `renderContents`. Anything else that adds to the cart goes unannounced —
  most visibly products tagged `use-gpo`, where the Globo options app takes
  over Add to cart and posts to /cart/add.js itself. The product is added,
  but the shopper sees nothing happen.

  So this watches every add instead of every button. fetch and
  XMLHttpRequest are wrapped; a successful POST to /cart/add that did NOT ask
  for `sections` (every theme form does) is one nobody will announce, so
  this fetches the notification's sections and opens it.

  Only ever additive: the original request and its response reach the caller
  untouched, and any failure in here is swallowed — a popup that cannot be
  shown must never break the add itself.
*/
(function () {
  if (window.__mtCartAddPopup) return;
  window.__mtCartAddPopup = true;

  var ADD_URL = /\/cart\/add(\.js)?(\?|$)/;
  var SECTIONS = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
  var nativeFetch = window.fetch;

  /* An add that already asks for the notification's sections is one the
     theme renders itself (product-form.js, quick-order-list.js). */
  function asksForSections(body) {
    if (!body) return false;
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) return body.has('sections');
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.has('sections');
      if (typeof body === 'string') return /"sections"\s*:|(^|&)sections=/.test(body);
    } catch (error) {}
    return false;
  }

  function isUnannouncedAdd(url, method, body) {
    return String(method || 'GET').toUpperCase() === 'POST' && ADD_URL.test(String(url || '')) && !asksForSections(body);
  }

  /* An add can come back as one line ({ key, … }) or several ({ items }).
     The options app adds a kit as several lines in one go — the kit line and
     one per part — and the popup should show the kit, so a line without
     `_gpo_parent_product_group` is preferred. Adds landing close together are
     batched so a kit sent as several requests still opens the popup once. */
  var pending = [];
  var timer = null;

  function collect(data) {
    if (!data) return;
    var lines = Array.isArray(data.items) ? data.items : data.key ? [data] : [];
    pending = pending.concat(lines);
    clearTimeout(timer);
    timer = setTimeout(flush, 200);
  }

  function pickLine(lines) {
    for (var i = 0; i < lines.length; i++) {
      var props = lines[i].properties || {};
      if (!props._gpo_parent_product_group) return lines[i];
    }
    return lines[0];
  }

  function flush() {
    var lines = pending;
    pending = [];
    var line = pickLine(lines);
    var notification = document.querySelector('cart-notification');
    /* No notification on this layout (the drawer cart type, or a page
       without the header): nothing to open. */
    if (!line || !line.key || !notification || typeof notification.renderContents !== 'function') return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    nativeFetch
      .call(window, root + '?sections=' + SECTIONS.join(','), { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (sections) {
        if (!sections) return;
        notification.renderContents({ key: line.key, sections: sections });
      })
      .catch(function () {});
  }

  /* ── fetch ───────────────────────────────────────────── */
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var promise = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        var method = (init && init.method) || (input && typeof input === 'object' && input.method);
        if (isUnannouncedAdd(url, method, init && init.body)) {
          promise
            .then(function (response) {
              if (!response.ok) return;
              return response
                .clone()
                .json()
                .then(collect);
            })
            .catch(function () {});
        }
      } catch (error) {}
      return promise;
    };
  }

  /* ── XMLHttpRequest (jQuery and older app scripts) ───── */
  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__mtAdd = { method: method, url: url };
      return open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        var info = this.__mtAdd;
        if (info && isUnannouncedAdd(info.url, info.method, body)) {
          this.addEventListener('load', function () {
            if (this.status < 200 || this.status >= 300) return;
            try {
              collect(JSON.parse(this.responseText));
            } catch (error) {
              /* A form-encoded add without .js answers with HTML, not JSON:
                 nothing to read a line key from, so no popup. */
            }
          });
        }
      } catch (error) {}
      return send.apply(this, arguments);
    };
  }
})();
